const { sanitizeFilename } = require("../../../libs/upload_filename");

(function () {
  const outingsCardsApp = function () {

    function extFromMime(type) {
      if (type === "image/png")  return ".png";
      if (type === "image/jpeg") return ".jpg";
      return "";
    }

    const onLogoChange = (e) => {
      const files = Array.from(e.target.files || []);
      if (files.length === 0) return;

      const dt = new DataTransfer();

      files.forEach((file) => {
        const safe = sanitizeFilename(file.name);
        const dot  = safe.lastIndexOf(".");
        const hasExt = dot !== -1;
        const forcedExt = extFromMime(file.type);

        let finalName = safe;
        if (forcedExt && (!hasExt || safe.slice(dot).toLowerCase() !== forcedExt)) {
          const stem = hasExt ? safe.slice(0, dot) : safe;
          finalName = `${stem}${forcedExt}`;
        }

        const safeFile = new File([file], finalName, {
          type: file.type,
          lastModified: file.lastModified,
        });

        dt.items.add(safeFile);
      });

      e.target.files = dt.files;
    };

    $(document).on('turbolinks:load', () => {
      if (!$('body').hasClass('controller-outings-cards')) return;

      $("#outings_card_config_logo").on('change', onLogoChange);
    });
  };

  if (typeof window !== 'undefined') {
    window.outingsCardsApp = outingsCardsApp();
  }
})();
